module.exports = __webpack_public_path__ + "img/seal-word.b8397bca.png";